Librarian.Window.MetaTreeWindow = new Class({
    Extends: Librarian.Window,
    Binds: ["onSubmitClicked", "onNodeChecked", "onTreeChildLoaded"],

    options: {
        id: "metaTreeWindow",
        treeContainer: "metaTreeCtrl",
        width: 360,
        height: 385,
        title: null,
        attributeId: -1,
        attributeName: null,
        selectedData: null,
        checkChildren: false
    },

    selectedData: [],
    treeView: null,
    onSubmit: null,

    initialize: function(options) {
        this.setOptions(options);

        if ((this.options.attributeId < 0) && ((this.options.attributeName || '').trim().length == 0))
            throw "Valid attribute ID not provided (" + this.options.attributeId + ')';

        if (options) {
            if (typeof options.onSubmit == "function")
                this.onSubmit = options.onSubmit;

            this.selectedData = options.selectedData || [];
        }

        // Set the title on init so that we can use the localization
        if ((this.options.title || '').trim().length == 0)
            this.options.title = Librarian.Lang.getString("metatree_title");

        this.options.contentURL = Librarian.path.getLayoutsPath() + "pages/metatreewindow.html";

        this.parent(this.options);
    },

    onWindowLoaded: function() {
        this.parent();
        this.setupElements();

        var itemEl = this.getElement("metaTreeSubmit");
        if (itemEl)
            itemEl.addOnClick(this.onSubmitClicked);

        itemEl = this.getElement("metaTreeCancel");
        if (itemEl)
            itemEl.addOnClick(this.close);

        this.loadTree();
    },

    onSubmitClicked: function() {
        if (typeof this.onSubmit == "function")
            this.onSubmit(this.selectedData);
        this.close();
    },

    onNodeChecked: function(node, checked) {
        if (checked) {
            if (!this.isSelected(node.data.attribcatid))
                this.selectedData.push(Object.subset(node, ["name", "descr", "data"]));
        }
        else
            this.removeSelected(node.data.attribcatid);

        // Make sure the children of this item have the same state
        if (this.options.checkChildren && node.hasChildren()) {
            node.recursive(function() {
                this.setCheckboxState(checked ? "checked" : "unchecked");
            });
        }
    },

    isSelected: function(attribCatId) {
        for (var i = this.selectedData.length; i--;) {
            if (this.selectedData[i].data.attribcatid == attribCatId)
                return true;
        }
    },
    
    removeSelected: function(attribCatId) {
        for (var i = this.selectedData.length; i--;) {
            if (this.selectedData[i].data.attribcatid == attribCatId) {
                this.selectedData.remove(i);
                break;
            }
        }
    },

    loadTree: function() {
        var contEl = this.getElement(this.options.treeContainer);
        if (!contEl)
            return;

        // Empty the tree container so we don't get duplicates
        contEl.empty();

        this.treeView = new Librarian.TreeView({
            container: contEl.id,
            method: "getatcat",
            rootMethod: "getatcat",
            checkBoxes: true,
            cookieStorage: false,
            rootCat: 0,
            params: {
                atid: this.options.attributeId,
                atname: this.options.attributeName
            },
            forest: true
        });

        this.treeView.load = function() {
            var url = this.options.rootUrl + "&m=" + this.options.rootMethod + "&out=mtree&pcid=" + this.options.rootCat;

            // If any extra parameters are given to pass in the request, add them here
            if ((typeof this.options.params == "object") && (this.options.params != null)) {
                for (var key in this.options.params) {
                    if (!this.options.params.hasOwnProperty(key))
                        continue;

                    url += '&' + key + '=' + this.options.params[key];
                }
            }

            this.baseLoad.apply(this, [
                {
                    noCache: true,
                    url: url
                }
            ]);
        }.bind(this.treeView);

        this.treeView.loadOptions = function(node) {
            var method = this.options.method,
                url = this.options.url;

            url += "&m=" + method + "&out=mtree&pcid=";

            if (node)
                url += node.data.attribcatid;
            else
                url += this.options.rootCat;

            // If any extra parameters are given to pass in the request, add them here
            if ((typeof this.options.params == "object") && (this.options.params != null)) {
                for (var key in this.options.params) {
                    if (!this.options.params.hasOwnProperty(key))
                        continue;

                    url += '&' + key + '=' + this.options.params[key];
                }
            }

            var options = {
                noCache: true,
                url: url,
                onFailure: Librarian.Utils.onFailure
            };

            return options;
        }.bind(this.treeView);

        this.treeView.addEvent("nodeCreate", this.onTreeChildLoaded);
        this.treeView.addEvent("switch", this.onNodeChecked);
        this.treeView.load();
    },

    onTreeChildLoaded: function(node) {
        if (!node)
            return;

        var checked = false;
        // Set previously selected items to be "Checked" on initial node load
        if (node.data && this.isSelected(node.data.attribcatid))
            checked = true;
        // If we're told to, check all children whose parent is checked
        else if (this.options.checkChildren) {
            var parent = node.getParent();
            if (parent && parent.state && (parent.state.checked == "checked"))
                checked = true;
        }

        if (checked)
            node.setCheckboxState("checked");
    }
});